import { SpinResponse } from '@cgs/data-access';
import {
  AbstractGameConfig,
  ComponentNames,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IconEnumerator,
  IconEnumeratorComponent,
  IGameConfigProvider,
  IGameStateMachineProvider,
  IReelsConfig,
  IReelsConfigProvider,
  ISlotGameEngineProvider,
  MultiSceneReelsEngineV2,
  T_IconEnumeratorComponent,
  T_IGameConfigProvider,
  T_IReelsConfigProvider,
  T_ISlotGameEngineProvider,
} from '@cgs/machines';

import { Container, EmptyAction, FunctionAction, IntervalAction, SequenceAction } from '@cgs/wge';

export const CORSICA_FREE_SPINS_END_COMPONENT_TOKEN = Symbol('CorsicaFreeSpinsEndComponent');

export class CorsicaFreeSpinsEndComponent {
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly reelsEngine: MultiSceneReelsEngineV2;
  private readonly reelsConfig: IReelsConfig;
  private readonly gameConfig: AbstractGameConfig;

  private readonly enumerator: IconEnumerator;
  private readonly config: AbstractGameConfig;

  constructor(container: Container) {
    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.reelsEngine = container.resolve<ISlotGameEngineProvider>(T_ISlotGameEngineProvider)
      .reelsEngine as MultiSceneReelsEngineV2;

    this.reelsConfig = container.resolve<IReelsConfigProvider>(T_IReelsConfigProvider).reelsConfig;

    this.gameConfig = container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;

    this.enumerator =
      container.resolve<IconEnumeratorComponent>(T_IconEnumeratorComponent).iconsEnumerator;

    this.config = container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;

    this.gameStateMachine.endFreeSpinsPopup.appendLazyAnimation(() => this.replaceReels());
  }

  private replaceReels(): IntervalAction {
    const startLine = 0 - this.reelsEngine.internalConfig.additionalUpLines;
    const endLine =
      this.reelsConfig.lineCount + this.reelsEngine.internalConfig.additionalBottomLines;

    return new SequenceAction([
      new EmptyAction().withDuration(0.5),
      new FunctionAction(() => {
        for (let reel = 0; reel < this.reelsConfig.reelCount; reel++) {
          for (let line = startLine; line < endLine; line++) {
            const entity = this.reelsEngine.getStoppedEntities(reel, line)[0];
            if (entity) {
              const iconId = this.gameConfig.staticConfig.noWinReels[reel][line + 1];
              const iconScene = this.reelsEngine.iconResourceProvider.getIconNodes(
                `icon_${iconId}`
              )![0];

              entity.removeComponent(ComponentNames.StickyIcon);
              entity.set(
                this.reelsEngine.entityEngine.getComponentIndex(ComponentNames.IconNode),
                iconScene
              );
              entity.set(
                this.reelsEngine.entityEngine.getComponentIndex(ComponentNames.DrawableIndex),
                iconId
              );

              this.reelsEngine.entityCacheHolder.replaceEntities(reel, line, [entity]);
            }
          }
        }
      }),
      new FunctionAction(() => {
        for (let reel = 0; reel < this.reelsConfig.reelCount; reel++) {
          for (let line = 0; line < this.reelsConfig.lineCount; line++) {
            this.enumerator.setMappedWinIndex(reel, line, 0);
          }
        }
        this.enumerator.setSpinedReels(this.config.staticConfig.spinedReels);
      }),
    ]);
  }
}
